import axios from '@/libs/axios'

const endpoint = 'confirmed-scientific-topic'

const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results || response.data)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

const get = ({ commit }, id) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/${id}/`)
    .then(response => {
      commit('GET', response.data)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

const create = (_, data) => axios.post(`/${endpoint}/`, {
  name_uz: data.name_uz,
  name_ru: data.name_ru,
  name_en: data.name_en,
  apply_doc: data.apply_doc,
  scientific_topic_protocol: data.scientific_topic_protocol,
})

const orgStudents = (_, queryParams) => axios.get('/apply-document/org_students/', { params: queryParams })

const searchApprovedTopics = (_, queryParams) => {
  const params = {}
  const allowedParams = ['dc_type', 'direction', 'limit', 'offset', 'organization', 'period_id', 'search']

  allowedParams.forEach(param => {
    if (queryParams[param] !== undefined && queryParams[param] !== null && queryParams[param] !== '') {
      params[param] = queryParams[param]
    }
  })

  return axios.get('/apply-documents/scientific-topics/', { params })
}

export default {
  list,
  get,
  create,
  orgStudents,
  searchApprovedTopics,
}
